import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { DocumentFileEditItem, IDocumentFileEditItem } from "./documentFileEditItem";
import { Base } from "ui/Scripts/source/framework/base";

export interface IDocumentFileEdit {
    path: string;
    keywords: IIdTitle[];
    item: IDocumentFileEditItem;
}

export class DocumentFileEdit implements IDocumentFileEdit {
    path: string;
    keywords: IdTitle[];
    item: DocumentFileEditItem;

    constructor();
    constructor(obj: IDocumentFileEdit);
    constructor(obj?: any) {
        this.path = obj && obj.path || "";
        this.keywords = Base.getTypedArray(obj ? obj.keywords : null, IdTitle);
        this.item = new DocumentFileEditItem(obj ? obj.item : null);
    }
}